import { Modal, FormField } from '@chikara/ui';
import { useApproveCardForm } from './useApproveCardForm';
import { formatCurrencyInput } from '@/features/card/components/ActivateCardModal/activateCard.validators';
import { Card } from '@/features/card/types/card.types';
import styles from './ApproveCardModal.module.css';
import { t } from '@/i18n';

interface ApproveCardModalProps {
    isOpen: boolean;
    onClose: () => void;
    card: Card;
    onSuccess: () => void;
}

export const ApproveCardModal = ({
    isOpen,
    onClose,
    card,
    onSuccess,
}: ApproveCardModalProps) => {
    const {
        limitInput,
        localError,
        isActionDisabled,
        handleLimitChange,
        handleConfirm,
    } = useApproveCardForm({ isOpen, onClose, card, onSuccess });

    const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        handleLimitChange(formatCurrencyInput(e.target.value));
    };

    return (
        <Modal
            isOpen={isOpen}
            onClose={onClose}
            title={t('dashboard.card.detail.modals.approveCard.title', { name: card.cardholderName })}
            actionLabel={t('dashboard.card.detail.modals.approveCard.confirm')}
            onAction={handleConfirm}
            isActionDisabled={isActionDisabled}
            secondaryActionLabel={t('dashboard.card.detail.modals.rejectCard.cancel')}
            onSecondaryAction={onClose}
        >
            <div className={styles.wizardContent}>
                <p className={styles.infoText}>
                    {t('dashboard.card.detail.modals.approveCard.description', {
                        last4: card.maskedPan.slice(-4),
                        email: card.email,
                        name: card.cardholderName
                    })}
                </p>

                <FormField
                    label={t('dashboard.card.detail.modals.approveCard.inputLabel')}
                    value={formatCurrencyInput(limitInput)}
                    onChange={handleInputChange}
                    error={localError || undefined}
                    className={localError ? styles.errorInput : ''}
                    inputMode="numeric"
                />
            </div>
        </Modal>
    );
};
